var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"list"}},_vm._l((_vm.list),function(drill,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":'/'+drill}},[_vm._v(_vm._s(drill))])],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }